import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

// Import SharedModule to get access to components
import { SharedModule } from './shared.module'

// Essential PrimeNG modules for lightweight usage
import { CorePrimeNGModule } from './core-primeng.module'
import { FormsPrimeNGModule } from './forms-primeng.module'
import { DataPrimeNGModule } from './data-primeng.module'

// Core modules
import { TranslateModule } from '@ngx-translate/core'

/**
 * YabiComponentsModule - Lightweight alternative to full SharedModule
 *
 * Provides the most commonly used shared components without the full SharedModule overhead:
 * - app-yabi-table (from SharedModule)
 * - app-yabi-input (from SharedModule)
 * - app-my-dialog (from SharedModule)
 * - app-modal-write-message (from SharedModule)
 * - app-allowed-permissions (from SharedModule)
 *
 * Plus essential PrimeNG modules and core functionality.
 *
 * Usage: Import this module instead of SharedModule when you only need basic components
 * Estimated bundle savings: 200-400KB per module compared to full SharedModule
 */
@NgModule({
  imports: [
    // Import SharedModule to get access to components
    SharedModule,

    // Essential modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CorePrimeNGModule,
    FormsPrimeNGModule,
    DataPrimeNGModule,
    TranslateModule,
  ],
  exports: [
    // Re-export SharedModule (this provides all components)
    SharedModule,

    // Export essential modules for convenience
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CorePrimeNGModule,
    FormsPrimeNGModule,
    DataPrimeNGModule,
    TranslateModule,
  ],
})
export class YabiComponentsModule {}
